import React from 'react';
import { motion } from 'framer-motion';
export function SolutionIntro() {
  return <section className="py-20 relative overflow-hidden" data-id="element-131">
      <div className="absolute inset-0 bg-brand-pink/5" data-id="element-132"></div>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-pink/50 to-transparent" data-id="element-133"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-pink/50 to-transparent" data-id="element-134"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-136">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-137">
            LA SOLUCIÓN: <br data-id="element-138" />
            <span className="text-brand-pink" data-id="element-139">MEGAPACK DEPILACIÓN TOTAL</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-10" data-id="element-140">
            Hemos empaquetado TODO el conocimiento de negocio estético en un
            sistema de 6 Tomos en PDF listos para descargar y aplicar hoy mismo.
          </p>

          <div className="max-w-md mx-auto relative" data-id="element-141">
            <div className="absolute inset-0 bg-brand-pink/20 blur-[60px] rounded-full pointer-events-none" data-id="element-142"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pRxD7QqzmXECtV51iHjRFf/heylloyd-image-1779601718801.png" alt="Megapack Preview" className="w-full h-auto object-contain relative z-10" data-id="element-143" />
          </div>
        </motion.div>
      </div>
    </section>;
}